module.exports = __webpack_public_path__ + "img/rw.7fe5146b.svg";